import React from 'react';

export default function PageBody({ bg = 'gray-200', className, children }) {
  return <div className={`px-3 px-md-5 py-4 py-md-5 bg-${bg} ${className}`}>{children}</div>;
}
